import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ShowCheckListActions {
  setIsHideCheckList: (isHideCheckList: boolean) => void;
  toggleShowCheckList: () => void;
}

interface ShowCheckListStore {
  isHideCheckList: boolean;
  actions: ShowCheckListActions;
}

const useShowCheckListStore = create<ShowCheckListStore>()(
  devtools(
    persist(
      set => ({
        isHideCheckList: false,
        actions: {
          setIsHideCheckList: (isHideCheckList: boolean) => set({ isHideCheckList }),
          toggleShowCheckList: () => set(state => ({ isHideCheckList: !state.isHideCheckList }))
        }
      }),
      {
        name: 'show-checklist-storage', // localStorage key
        partialize: state => ({ isHideCheckList: state.isHideCheckList })
      }
    )
  )
);

export const useIsHideCheckList = () => useShowCheckListStore(state => state.isHideCheckList);
export const useShowCheckListActions = () => useShowCheckListStore(state => state.actions);
